import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal, ChatDocumentModal } from 'src/modules/shared';
import {
  AuditTrailDetailModal,
  FieldChangeModal,
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { ViewHistoryModal } from '../../../../modals/view-history-modal/view-history-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, map } from 'rxjs/operators';
import {
  DocUploadModal,
  EditDocumentsModal,
} from 'src/modules/features/contractor/modals';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
import { DocumentTypeService } from 'src/modules/features/setting/services';
import {
  CompanyService,
  DashboardProvider,
  DocumentService,
} from '../../../../services';
import { DocumentTypeModal } from 'src/modules/features/contractor/modals/document-type-modal/document-type-modal.component';
import { PdfViewerService } from 'src/modules/features/contractor/services/pdfViewer';

@Component({
  selector: 'app-offical-supporting-documents',
  templateUrl: './offical-supporting-documents.component.html',
  styleUrls: ['./offical-supporting-documents.component.scss'],
})
export class OfficalSupportingDocumentsComponent implements OnInit {
  documents = [];
  projectId: string;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  filter2: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  directorStatus: string;
  isPending: boolean = false;
  activeDocuments;
  searchFilters = {
    groupOp: 'AND',
    rules: [
      {
        field: 'documentId.documentName',
        op: 'cn',
        data: '',
      },
    ],
  };
  expandedIndex: number | null = null;
  baseUrl = environment.API_SERVER;
  documentsType: Array<any> = [];
  uploadFormData: any;
  isAttachmentView: boolean = false;
  permissions: Array<any> = [];
  dataSent;
  chatLink;
  expandedID: string | null = null;
  documentStatus: string;
  allHistory: any;
  totalItemsHistory: number;
  totalItems2;
  allDocumentTypes = [];
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private organizationSvc: OrganizationService,
    private documentSvc: DocumentService,
    private documentTypeSvc: DocumentTypeService,
    private dashboardSvc: DashboardProvider,
    private companySvc: CompanyService,
    private pdfViewerService: PdfViewerService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10000 });
    // this.filter.filters = JSON.stringify(this.searchFilter);

    this.getOptionTypes();
    this.getVerifiedCount();
    this.getPendingCount();
    this.getArchivedPage(1);
    this.getHistory(1);

    this.chatLink = `/contractor/chat/${this.organizationId}/message`;
  }
  selectDocType() {
    this.modalService
      .open(new DocumentTypeModal('Select Document type', this.documentsType))
      .onApprove((doc) => {
        this.uploadDoc(doc);
      });
  }

  uploadDoc(val) {
    let payload = this.documentTypesCombined.filter((item) => {
      return item.documentTypeId === val;
    });
    this.modalService
      .open(
        new ChatDocumentModal(
          'Upload Document',
          payload[0],
          null,
          ModalSize.Mini
        )
      )
      .onApprove((payload: any) => {
        this.uploadFormData = payload['formData'];
        const values = payload['formValue'];
        this.dataSent = values;
        const jsonse = JSON.stringify(values);
        const blob = new Blob([jsonse], { type: 'application/json' });
        this.uploadFormData.append('data', blob);
        this.onUploadFile(this.uploadFormData);
        // this.replyForm.patchValue(payload['formValue']);
      })
      .onDeny(() => {});
  }
  editDoc(val) {
    console.log(val, this.documentsType);
    let payload = this.allDocumentTypes.filter((item) => {
      return item.documentTypeId === val.id;
    });
    console.log(payload);
    this.modalService
      .open(
        new ChatDocumentModal(
          'Upload Document',
          payload[0],
          val,
          ModalSize.Mini
        )
      )
      .onApprove((payload: any) => {
        this.uploadFormData = payload['formData'];
        const values = payload['formValue'];
        this.dataSent = values;
        const jsonse = JSON.stringify(values);
        const blob = new Blob([jsonse], { type: 'application/json' });
        this.uploadFormData.append('data', blob);
        this.onUploadFile(this.uploadFormData);
        // this.replyForm.patchValue(payload['formValue']);
      })
      .onDeny(() => {});
  }
  viewHistory(item) {
    this.modalService.open(
      new ViewHistoryModal(
        'View History Record',
        'OFFICIAL_DOCUMENT',
        {
          isPending: false,
        },
        this.organizationId,
        item.changeRequestId
      )
    );
  }
  checkPermission(id: string, action: string): boolean {
    // return true
    if (
      this.permissions.filter(
        (res: { permissionId: string }) => res.permissionId === id
      )[0] &&
      this.permissions.filter(
        (res: { permissionId: string }) => res.permissionId === id
      )[0][action] === 'true'
    ) {
      return true;
    } else {
      return false;
    }
  }

  onUploadFile(data) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          // this.pending = false;
          this.saveDoc(res);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getHistory(page) {
    this.pending = true;
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: 'OFFICIAL_DOCUMENT',
        params: this.filter2,
      })
      .pipe(
        tap((res) => {
          this.totalItemsHistory = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.allHistory = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getOptionTypes() {
    let filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10000,
      sord: 'desc',
    });
    // filter.filters = JSON.stringify({
    // 	groupOp: 'AND',
    // 	rules: [
    // 		{
    // 			field: 'documentTypeName',
    // 			op: 'cn',
    // 			data: ''
    // 		}
    // 	]
    // });
    // this.documentTypeSvc.getDocumentType({ params: filter }).subscribe(
    //   (res: any) => {
    //     // this.optionLoading = false;
    //     this.documentsType = res['rows'];
    //     this.documentsType = this.documentsType.filter((item) => item.isActive);
    //   },
    //   (error) => {}
    // );
    this.getDocumentUploaded();
  }
  getDocumentUploaded() {
    this.pending = true;
    this.documentTypeSvc.getSupportingDocumentUpload().subscribe(
      (res: any) => {
        this.pending = false;
        this.documentsType = res.filter((item) => item.isActive);
        this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }
  saveDoc(document) {
    this.pending = true;
    this.organizationSvc
      .addSupportingDocument({
        documentId: document.documentId,
        body: {},
      })
      .subscribe(
        (res) => {
          this.success = 'Supporting Documents added successfully. ';
          this.pending = false;
          this.getOptionTypes();
          setTimeout(() => {
            this.router.navigateByUrl(
              '/contractor/company/supporting-document/official-supporting?documentStatus=verified'
            );
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  onUploadFileDoc(data, id) {
    this.documentSvc
      .uploadSupportingDocument({
        changeRequestId: id,
        body: data,
      })
      .subscribe(
        (res) => {
          // this.pending = false;
          this.success =
            'Official Documents updated successfully. You will be notified when your request has been verified';
          this.pending = false;
          setTimeout(() => {
            this.router.navigateByUrl(
              '/contractor/company/supporting-document/official-supporting?documentStatus=verified'
            );
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getVerificationStatus() {
    let organization = JSON.parse(window.localStorage.getItem('organization'));
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.directorStatus = res['OFFICIAL_DOCUMENT'];

          res['OFFICIAL_DOCUMENT'] === 'UNVERIFIED' ||
          res['OFFICIAL_DOCUMENT'] === 'PENDING'
            ? (this.isPending = true)
            : (this.isPending = false);
          this.pending = false;
        },
        (error) => {
          this.directorStatus = 'NOT_AVAILABLE';
          this.isPending = false;
          this.pending = false;

          // this.error = error.error.errorMessage
          //   ? error.error.errorMessage
          //   : error.error
          //   ? error.error
          //   : error;
        }
      );
  }
  addDocument() {
    this.modalService
      .open(
        new DocUploadModal(
          'Select Document',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  goBack() {
    this.location.back();
  }
  view(payload) {
    if (payload.document.extension == 'image') {
      this.pdfViewerService.viewPdf(payload.document, 'image');
      // url = `${this.baseUrl}/public/image/?media=${payload.documentId.documentPath}`;
    } else {
      this.pdfViewerService.viewPdf(payload.document);
    }
  }
  download(payload) {
    let url;

    if (payload.document.extension == 'image') {
      url = `${this.baseUrl}/public/image/?media=${payload.document.documentPath}`;
    } else {
      url = `${this.baseUrl}/public/media/?media=${payload.document.documentPath}`;
    }
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute(
          'download',
          `${payload.document.documentPath}.${payload.document.extensionGroup}`
        );
        a.click();
      });
    });
  }

  editDocument(item) {}

  archivedDocs = [];
  archivedDocuments;
  totalArchived: number = 0;

  getArchivedPage(page: number) {
    this.filter.page = page;
    this.pending = true;
    if (this.isAttachmentView === false) {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'false';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    } else {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'true';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    }
    this.documentSvc
      .getDocument({
        organizationId: this.organizationId,
        status: 'ARCHIVED',
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalArchived = +res.records;
          this.rows = this.filter.rows;
          this.archivedDocs = res['rows'];
          const groupedObjects = this.archivedDocs.reduce((result, obj) => {
            const key = obj.documentId.documentTypeId.documentTypeName;
            if (!result[key]) {
              result[key] = [];
            }
            result[key].push(obj);
            return result;
          }, {});

          this.archivedDocuments = Object.entries(groupedObjects).map(
            ([key, value]) => ({ key, value })
          );
          this.appendCollapseState2(this.archivedDocuments);
          this.totalItems2 = this.archiveDocument.length;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  documentTypesCombined;
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    if (this.isAttachmentView === false) {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'false';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    } else {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'true';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    }
    this.filter['organizationId'] = this.organizationId;
    this.documentSvc
      .getAllSupportingDocument({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.rows = this.filter.rows;
          this.documents = res['rows'];
          let groupedObjects2 = this.documents.reduce((result, obj) => {
            const key = obj.document.documentTypeId.documentTypeName;
            const typeId = obj.document.documentTypeId.documentTypeId;
            if (!result[key]) {
              result[key] = [];
            }
            result[key].push(obj);
            if (!result[typeId]) {
              result[typeId] = [];
            }
            result[typeId].push(obj);

            return result;
          }, {});
          let groupedObjects3 = Object.values(groupedObjects2).flatMap(
            (value) =>
              (value as { document: any }[]).map(
                (item) => item.document.documentTypeId
              )
          );
          const uniqueDocumentTypes = new Set<number>();
          for (const document of groupedObjects3) {
            if (!uniqueDocumentTypes.has(document.documentTypeId)) {
              this.allDocumentTypes.push(document);
              uniqueDocumentTypes.add(document.documentTypeId);
            }
          }
          const groupedObjects = this.documents.reduce((result, obj) => {
            const key = obj.document.documentTypeId.documentTypeName;
            if (!result[key]) {
              result[key] = [];
            }
            result[key].push(obj);
            return result;
          }, {});
          this.activeDocuments = Object.entries(groupedObjects).map(
            ([key, value]) => ({
              key,
              id: value[0].document.documentTypeId.documentTypeId,
              required: value[0].document.documentTypeId.isRequired,
              value,
            })
          );
          (this.documentTypesCombined = this.mergeArrays(
            this.activeDocuments,
            this.documentsType
          )),
            this.documentTypesCombined.sort(
              (a, b) => b.isRequired - a.isRequired
            );
          this.appendCollapseState(this.documentTypesCombined);
          this.totalItems = this.documentTypesCombined.length;
          this.getVerificationStatus();
          console.log(this.documentTypesCombined, 'herecombined');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  returnLength(value) {
    if (value) {
      let data = value.filter((item) => {
        return item.status === 'ACTIVE';
      });
      return data.length;
    } else {
      return 0;
    }
  }
  mergeArrays(firstArray, secondArray) {
    if (firstArray.length === 0) {
      return secondArray.map((secondObj) => ({ ...secondObj, value: [] }));
    } else {
      // Otherwise, merge the objects as described previously
      return secondArray.map((secondObj) => {
        const matchingObj = firstArray.find(
          (firstObj) => firstObj.id === secondObj.documentTypeId
        );
        if (matchingObj) {
          return { ...secondObj, ...matchingObj };
        }
        return secondObj;
      });
    }
  }
  toggleAffiliateTypesVisibility(index: number, id?) {
    this.expandedID = this.expandedID === id ? null : id;
    this.documentTypesCombined[index]['isCollapsed'] =
      !this.documentTypesCombined[index]['isCollapsed'];

    if (this.documentTypesCombined[index]['isCollapsed']) {
      this.router.navigate(
        ['/contractor/company/supporting-document/official-supporting'],
        {
          queryParams: { documentStatus: 'verified' },
        }
      );
    }
  }
  appendCollapseState(data) {
    this.documentTypesCombined.forEach((record) => {
      record['isCollapsed'] = true;
    });
  }
  appendCollapseState2(data) {
    this.archivedDocuments.forEach((response) => {
      response['isCollapsed'] = true;
    });
  }
  searchRecords(search) {
    // let searchFil = {
    //   groupOp: 'AND',
    //   rules: [
    //     // {
    //     //   field: 'documentId.attachment',
    //     //   op: 'eq',
    //     //   data: false,
    //     // },
    //     {
    //       field: 'documentId.documentName',
    //       op: 'cn',
    //       data: '',
    //     },
    //   ],
    // };
    this.searchFilters.rules[0].data = search;
    this.filter.filters = JSON.stringify(this.searchFilters);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  delete(event: any): void {
    this.pending = true;
    this.error = null;
    this.documentSvc
      .removeDocument({
        organizationId: this.organizationId,
        id: event.organizationDocumentId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success =
            'Document removed successfully. You will be notified when your changes are verified';
          this.getPage(this.filter.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getVerifiedCount(): number {
    return this.documents.filter((doc) => doc.verificationStatus === 'VERIFIED')
      .length;
  }
  getPendingCount(): number {
    return this.documents.filter((doc) => doc.verificationStatus == 'PENDING')
      .length;
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Document?',
          'Are you sure you want to remove document?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }

  onArchive(item) {
    this.modalService
      .open(
        new ConfirmModal(
          'Archive Document?',
          'Are you sure you want to move this document to archive?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.archiveDocument(item);
      })
      .onDeny(() => {});
  }
  onUnArchive(item) {
    this.modalService
      .open(
        new ConfirmModal(
          'Restore Document?',
          'Are you sure you want to restore this document from archive?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.unArchiveDocument(item);
      })
      .onDeny(() => {});
  }
  editName(item) {
    this.modalService
      .open(new EditDocumentsModal('Edit Document Name', item, ModalSize.Mini))
      .onApprove(() => {
        this.getOptionTypes();
      })
      .onDeny(() => {});
  }
  unArchiveDocument(val) {
    this.pending = true;
    this.documentSvc
      .updateSupportingDocument({
        supportingDocumentId: val.supportingDocumentId,
        status: 'ACTIVE',
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Document successfully restored';
          this.getOptionTypes();
          setTimeout(() => {
            this.router.navigateByUrl(
              '/contractor/company/supporting-document/official-supporting?documentStatus=verified'
            );
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  archiveDocument(val) {
    this.pending = true;
    this.documentSvc
      .updateSupportingDocument({
        supportingDocumentId: val.supportingDocumentId,
        status: 'ARCHIVED',
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Document successfully moved to archive';
          this.getOptionTypes();
          setTimeout(() => {
            this.router.navigateByUrl(
              '/contractor/company/supporting-document/official-supporting?documentStatus=archive'
            );
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  comment(item) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((res) => {
      if (res['documentStatus']) {
        // this.requestType = res['requestType'] === 'class_license' ? 'NEW_CLASS_LICENSE' : (res['requestType']).toUpperCase();
        this.documentStatus = res['documentStatus'];
      } else {
        this.documentStatus = 'verified';
        this.router.navigate(
          ['/contractor/company/supporting-document/official-supporting'],
          {
            queryParams: { documentStatus: 'verified' },
          }
        );
      }
      // this.getPage(1);
    });
  }
}
